<script>
import { range } from "../utils/range.js";

export default {
  data() {
    return {};
  },

  computed: {
    brands() {
      return this.$store.state.brands;
    },
    range() {
      return range;
    },
  },
};
</script>

<template>
  <section id="being" class="being">
    <div class="container">
      <h2>Nosso Jeito de Ser</h2>
      <div class="row being__cards">
        <div class="col-lg-4 col-md-6 px-2" v-for="item in 6" :key="item">
          <div
            class="
              being__card
              d-flex
              align-items-center
              justify-content-center
              flex-column
            "
          >
            <div class="being__card__image">
              <img
                :src="
                  require(`@/assets/images/smart_fit/nossojeito0${item}.png`)
                "
                alt=""
              />
            </div>
            <div class="being__card__text">
              <div v-html="range[item - 1].content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container more" id="sobre-nos">
      <h2>Quem Somos</h2>
      <p class="text-justify">
        Você está pronto para fazer parte da verdadeira transformação do mundo fitness e levar ainda mais saúde e qualidade de vida às pessoas?
        <br><br>
        Então, você está no lugar certo! O Grupo Smart Fit é a maior rede de academias da América Latina e o maior empregador de profissionais de educação física do mundo. Mas, é mais que isso: somos um verdadeiro ecossistema voltado ao bem-estar e à saúde, pois impactamos milhares de vidas com nossa rede de academias espalhadas em diversos países, nossas plataformas digitais voltadas a treinos e nutrição e nossos produtos físicos, que impulsionam ainda mais os resultados, sem falar, é claro, de dar a liberdade para nossos alunos se exercitarem de onde estiverem.<br><br>
        Nosso grupo é composto pelas academias Bio Ritmo, Bio Smart Fit, Race Bootcamp, Vidya, Jab House, Tonus Gym, TotalPass e pelos produtos digitais como: Queima Diária, Smart Fit Nutri, Smart Fit Coach entre outros, sempre buscando oferecer soluções híbridas e completas para quem quer ter um estilo de vida mais ativo e saudável.
      </p>

      <div class="row more__images">
        <div class="col-lg-8 pr-lg-2">
          <div class="img"></div>
        </div>
        <div class="col-lg-4 mt-4 mt-lg-0 pl-lg-2">
          <div class="img img--2"></div>
        </div>
      </div>

      <div class="row more__infos d-flex align-items-center flex-lg-nowrap">
        <div class="col-lg-3">
          <span> Há <strong>28 anos</strong> </span>
          <span class="b"> no mercado </span>
        </div>
        <div class="col-lg-3">
          <span> <strong class="b"> +4 milhões</strong> de alunos </span>
        </div>
        <div class="col-lg-3 more--m">
          <span> <strong class="b">+1300 academias</strong></span>
          <span class="b">no Brasil e na</span>
          <span class="b">América Latina</span>
        </div>
        <div class="col-lg-3">
          <span> Presente em <strong class="b">15 países</strong></span>
        </div>
      </div>

      <h3 class="mt-5 mb-3">
        Descubra mais sobre o Grupo Smart Fit e o que o torna tão inovador.
      </h3>
    </div>

    <div class="embed-responsive">
      <video class="embed-responsive-item" controls>
        <source :src="require(`@/assets/videos/video-home.mp4`)">
      </video>
    </div>

    <!-- <a :href="require(`@/assets/videos/video-home.mp4`)" class="glightbox" >
      <img :src="require(`@/assets/images/smart_fit/more3.jpg`)">
    </a> -->

  </section>
</template>

<style lang="scss">
.being {
  margin: 5rem 0px;

  .img3 {
    max-height: 650px;
    overflow: hidden;

    @media all and (min-width: 1600px) {
      max-height: 850px;
    }
  }

  .embed-responsive{
    background: black;
    height: 550px;
    overflow: hidden;

    video{
      top: 10px;
      height: calc(100% - 20px);
    }

    @media all and (min-width: 1600px) {
      max-height: 850px;
    }
  }

  &__cards {
    margin-top: 2rem;
    text-align: center;
  }
  &__card {
    box-shadow: 0px 4px 12px 8px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    min-height: 368px;
    box-sizing: border-box;
    margin-top: 1rem;
    &__image {
      img {
        width: 110px;
        height: auto;
        margin: 0 auto;
        display: block;
        margin-bottom: 1.5rem;
      }
    }
    &__text {
      span {
        font-size: 1.8rem;
        display: block;
        color: #000;
        line-height: calc(2.2rem * 1.25);

        strong {
          font-weight: bold;
        }
        u {
          text-decoration: none;
          border-bottom: 4px solid rgba(#000, 0.5);
          &.primary {
            border-color: theme-color(primary);
          }
        }
      }
      .range {
        color: #fff;
        font-weight: bold;
        width: auto;
        mark {
          background-color: theme-color(primary);
          color: #fff;
          padding: 0.2rem 2rem;
          position: relative;
          white-space: nowrap;
          &.custom {
            &::before {
              content: "";
              top: 0;
              position: absolute;
              border-top: 18px solid transparent;
              border-bottom: 18px solid transparent;
              border-left: 20px solid #fff;
              left: 0;
            }
            &::after {
              content: "";
              top: 0;
              position: absolute;
              border-top: 18px solid transparent;
              border-bottom: 18px solid transparent;
              border-right: 20px solid #fff;
              right: 0;
            }
          }
          &.light {
            font-weight: 300;
            padding: 0.1rem 1rem;
          }
        }
      }
    }
  }
  .more {
    margin-top: 6rem;
    p {
      font-size: 1.9rem;
      line-height: calc(1.9rem * 1.2);
      color: #000;
      margin-top: 1rem;
      @include media-breakpoint-down(md) {
        font-size: 1.2rem;
        line-height: calc(1.2rem * 1.2);
      }
    }
    &__images {
      margin-top: 4rem;
      .img {
        height: 400px;
        width: 100%;
        overflow: hidden;
        background: url("../../../assets/images/smart_fit/more1.jpg") no-repeat
          center center;
        background-size: cover;
        &--2 {
          background: url("../../../assets/images/smart_fit/more2.jpg")
            no-repeat center center;
          background-size: cover;
          border-radius: 4px;
        }
      }
    }
    &__infos {
      min-height: 152px;
      margin-top: 2rem;
      .more--m {
        margin-right: 4.5rem;
      }
      & > div {
        min-height: 142px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 3rem;
        &::before {
          content: "";
          width: 6px;
          height: 100%;
          left: 1rem;
          position: absolute;
          background-color: #7a7878;
          border-radius: 20px;
        }
      }
      span {
        &.b {
          display: block;
        }
        font-size: 1.7rem;
        line-height: calc(1.7rem * 1.5);
        color: #000;
        white-space: nowrap;
        strong {
          &.b {
            display: block;
          }
        }
      }
    }
  }
}
</style>